import { Heading, Text } from "@ttc3k/trekker";
import { EnumSurveyQuestionType } from "gql/generated";
import { getMultilingualString } from "shared/utils";
import { Flex } from "styled-system/jsx";
import type { SurveyQuestionLike } from "./surveyQuestionDesign";

type SurveyDesignFieldProps = {
  question: SurveyQuestionLike;
};

export const SurveyDesignField = ({ question }: SurveyDesignFieldProps) => {
  const content = getMultilingualString(question.name ?? {});

  if (question.type === EnumSurveyQuestionType.SectionHeading) {
    return (
      <Flex
        flexDir="row"
        justifyContent="space-between"
        alignItems="center"
        pb="150"
        borderBottomWidth="2px"
        borderBottomColor="border.light"
        w="full"
      >
        <Heading
          size="h2"
          fontSize="lg"
          lineHeight="sm"
          letterSpacing="normal"
          color="text.dark"
        >
          {content}
        </Heading>
      </Flex>
    );
  }

  return (
    <Text visual="bodyRegular" color="text.dark" whiteSpace="pre-wrap">
      {content}
    </Text>
  );
};
